import { createAction } from '@reduxjs/toolkit';

export const toggleOrderIdCollapsible = createAction<number | undefined>('collapsible/toggleOrderIdCollapsible');
export const clearOrderCollapsible = createAction('collapsible/clearOrderCollapsible');

export const togglePurchaseOrderIdCollapsible = createAction<number | undefined>(
    'collapsible/togglePurchaseOrderIdCollapsible',
);
export const clearPurchaseOrderCollapsible = createAction('collapsible/clearPurchaseOrderCollapsible');

export const toggleDemandOrderIdCollapsible = createAction<number | undefined>(
    'collapsible/toggleDemandOrderIdCollapsible',
);
export const clearDemandOrderCollapsible = createAction('collapsible/clearDemandOrderCollapsible');

export const toggleGeneralReturnOrderIdCollapsible = createAction<number | undefined>(
    'collapsible/toggleGeneralReturnOrderIdCollapsible',
);
export const clearGeneralReturnOrderCollapsible = createAction('collapsible/clearGeneralReturnOrderCollapsible');

export const toggleGoodsIdCollapsible = createAction<number | undefined>('collapsible/toggleGoodsIdCollapsible');
export const clearGoodsCollapsible = createAction('collapsible/clearGoodsCollapsible');
